<ll-titulo>Editar post #{{ postId }}</ll-titulo>
<ll-toolnavbar>
    <posts-toolnavbar [displayButtons]="'all new'" [postId]="postId"></posts-toolnavbar>
</ll-toolnavbar>

<posts-edit [postId]="postId"></posts-edit>
